exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropbox {\n  outline: 2px dashed grey; /* the dash box */\n  outline-offset: -10px;\n  background: #ddd;\n  color: black;\n  min-height: 300px; /* minimum height */\n  position: relative;\n  cursor: pointer;\n  flex-direction: column;\n}\n.dropbox:hover {\n  background: #ccc; /* when mouse over to the drop zone, change color */\n}\n.input-file {\n  opacity: 0; /* invisible but it's there! */\n  width: 100%;\n  position: absolute;\n  cursor: pointer;\n}\n.dropbox p {\n  font-size: 1.2em;\n  text-align: center;\n}\n.progress-bar-container {\n  width: 70%;\n  margin: 0 auto;\n}", ""]);

// exports
